import { render } from "./walk-school.vue?vue&type=template&id=2e28e9cd"
import script from "./walk-school.vue?vue&type=script&lang=js"
export * from "./walk-school.vue?vue&type=script&lang=js"

import "./walk-school.vue?vue&type=style&index=0&id=2e28e9cd&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__